import { useMemo } from 'react';
import withGateOverride from '../utils/withGateOverride';
import { useSafeSelector } from './useSafeSelector';
export function useIsUngated(gateName) {
  const maybeState = useSafeSelector(state => state);
  const isUngated = useMemo(() => {
    var _maybeState$auth;
    return maybeState === null || maybeState === void 0 || (_maybeState$auth = maybeState.auth) === null || _maybeState$auth === void 0 ? void 0 : _maybeState$auth.gates.includes(gateName);
  }, [maybeState, gateName]);
  return withGateOverride(gateName, isUngated);
}